import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useTheme } from '../ThemeContext';
import { Spacing } from '../theme/Spacing';
import { Tooltip } from '../utils/local-antd';
import { Slider, SliderSingleProps } from '../utils/local-antd';
import { AtiraIcon } from './AtiraIcon';
import { Flex } from './Flex';
import { Text } from './Text';

const StyledLabel = styled.label`
  cursor: pointer;
  color: ${({ theme }) => theme.fgPrimary};
  width: fit-content;
  flex: 1;
`;

const OptionalSpan = styled.span`
  color: ${({ theme }) => theme.fgMuted};
  display: inline-block;
  margin-inline-start: ${Spacing.s};
`;

export interface AtiraSliderProps extends SliderSingleProps {
  title?: string;
  valid?: boolean;
  errorMessage?: string;
  dataTestId?: string;
  info?: string;
  required?: boolean;
  width?: string;
}

export const AtiraSlider: React.FC<AtiraSliderProps> = ({
  title,
  valid,
  errorMessage,
  info,
  required,
  width,
  dataTestId,
  ...props
}) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column" gap="s" width={width || '100%'}>
      <Flex width={'100%'} gap="s" flexDirection="column">
        {title ? (
          <StyledLabel>
            {info ? (
              <Tooltip title={info}>
                <AtiraIcon icon={faInfoCircle} color="fgPrimary" />
                {/* don't delete this span */}
                <span style={{ marginInlineEnd: '0.2rem' }}></span>
              </Tooltip>
            ) : null}
            {title}

            {required ? (
              <span style={{ color: theme.danger }}> *</span>
            ) : (
              <OptionalSpan>({t('common.optional')})</OptionalSpan>
            )}
          </StyledLabel>
        ) : null}

        <Flex flexDirection="column" position="relative" gap="s">
          <Slider {...props} className={dataTestId} />

          {errorMessage && valid === false ? (
            <Text color="danger" fontSize="s" style={{ marginTop: Spacing.s }}>
              {errorMessage}
            </Text>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
};
